import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { API_ROUTES } from "utils/constant";
import { axiosPatch } from "utils/api";

function WhitelistIpEditDialog({ isOpen, onClose, detail, refetch }) {
  const [note, setNote] = useState(detail?.note || "");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  async function handleSubmit() {
    setLoading(true);
    try {
      const res = await axiosPatch(API_ROUTES.IpUpdate(detail._id), {
        note: note.trim(),
      });
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Cập nhật thất bại",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "Đã cập nhật ghi chú",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      refetch?.();
      onClose();
    } catch (error) {
      toast({
        title: error?.response?.data?.msg || "Cập nhật thất bại",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Sửa ghi chú IP</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="3" fontSize="sm" color="gray.500">
            IP: <b>{detail?.ip}</b>
          </Text>
          <FormControl>
            <FormLabel>Ghi chú</FormLabel>
            <Input
              placeholder="vd. CS team, Yuri 8day, ..."
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr="3" onClick={onClose}>
            Huỷ
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>
            Lưu
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default WhitelistIpEditDialog;
